import { Box, GlobalStyles, styled } from '@mui/system';

type BackgroundGlobalStyleProps = {
  mobileColor?: string;
  desktopColor?: string;
};

export const BackgroundGlobalStyle = ({
  mobileColor = 'white',
  desktopColor = 'gray',
}: BackgroundGlobalStyleProps) => {
  const colorMap = {
    white: '#ffffff',
    gray: '#f9f9f9',
  };
  return (
    <GlobalStyles
      styles={{
        body: {
          backgroundColor: colorMap[mobileColor] || '#ffffff',
          '@media (min-width: 900px)': {
            backgroundColor: colorMap[desktopColor] || '#f9f9f9',
          },
        },
      }}
    />
  );
};

type PageWrapperProps = {
  disableMobilePadding?: boolean;
  addHeaderPadding?: boolean;
};

export const PageWrapper = styled(Box, {
  shouldForwardProp: (prop) =>
    prop !== 'disableMobilePadding' && prop !== 'addHeaderPadding',
})<PageWrapperProps>(
  ({ disableMobilePadding, addHeaderPadding = true, theme }) => ({
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '16px',
    overflow: 'auto',
    padding: disableMobilePadding
      ? '0 0 32px 0'
      : addHeaderPadding
      ? '104px 12px 16px 12px'
      : '40px 12px 16px 12px',
    [theme.breakpoints.up('md')]: {
      padding: '40px 12px 16px 12px',
    },
  }),
);
